import { ProjectTypes } from '@platform/types';
import React from 'react';
import { Modal, Tabs } from '../../shared';
import SocialExplorer from './SocialExplorer';
import UserUploads from './UserUploads';

interface Props {
  onSelect: (workingLayers: ProjectTypes.AnyWorkingLayer[]) => void;
  onCloseRequest: () => void;
}

const NewWorkingLayerPickerModal: React.FC<Props> = ({ onCloseRequest, onSelect }) => {
  const tabs = [
    {
      key: 'social-explorer',
      label: 'SE Library',
      children: <SocialExplorer onSelect={onSelect} onCancel={onCloseRequest} />,
    },
    {
      key: 'catalog',
      label: 'Catalog',
      children: <UserUploads onSelect={onSelect} onCancel={onCloseRequest} />,
    },
  ];

  return (
    <Modal title="Add layer to map" hideActions className="w-[1000px]" onCloseRequest={onCloseRequest}>
      <div className="-mx-6">
        <Tabs tabProps={tabs} />
      </div>
    </Modal>
  );
};

export default NewWorkingLayerPickerModal;
